import React from 'react';

const PolicyContent = () => {
	return (
		<>
			<div className='policy'>
				<h2>Polityka prywatności</h2>
				<p>
					Informacja dla Klienta o przetwarzaniu danych osobowych przez
					Stowarzyszenie FPUNKT z siedzibą: ul. Długa 24A 84-353 Mosty, NIP: 841 171 94 70, KRS: 0000642213, REGON: 365658076
				</p>
				<ol>
					I Zgodnie z art.13 ust. 1 i 2 Ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r. (dalej jako Ogólne rozporządzenie) informujemy, że:
					<li>
						Podanie przez Pana/Panią swoich danych osobowych oraz danych osobowych dziecka jest dobrowolne, ale niezbędne dla wykonania rezerwacji oraz realizacji projektów edukacyjnych i innych działań edukacyjnych Stowarzyszenia.
					</li>
					<li>
						Administratorem Pana/Pani danych osobowych oraz danych osobowych dziecka jest Stowarzyszenie FPUNKT z siedzibą: ul. Długa 24A, 84-353 Mosty
					</li>
					<li>
						Przekazane przez Pana/Panią dane osobowe będą przetwarzane wyłącznie w celu wykonania rezerwacji niezbędnej dla zawarcia umowy uczestnictwa Pana/Pani dziecka w organizowanym przez Administratora turnusie, a także w celu realizacji projektów edukacyjnych i innych działań edukacyjnych Stowarzyszenia, zgodnie z art. 6 ust. 1 lit. b Ogólnego rozporządzenia.
					</li>
					<li>
						Przetwarzanie danych osobowych w celach reklamowania Panu/Pani pozostałych usług Stowarzyszenie FPUNKT z siedzibą: ul. Długa 24A, 84-353 Mosty wymaga uzyskania Pana/Pani wyraźnej zgody.
					</li>
					<li>
						Przekazane przez Pana/Panią dane osobowe nie będą udostępniane w żaden sposób innym podmiotom, za wyjątkiem organów publicznych, które mogą otrzymywać dane osobowe w ramach konkretnego postępowania przewidzianego prawem UE lub przepisami prawa polskiego.
					</li>
					<li>
						Przekazane przez Pana/Panią dane osobowe mogą zostać powierzone wyłącznie: – przedsiębiorstwom IT zajmującym się obsługą informatyczną oraz prowadzeniem strony internetowej Administratora.
					</li>
					<li>
						7.	Przekazane przez Pana/Panią dane osobowe będą przechowywane w zbiorach danych osobowych prowadzonych przez Administratora przez okres realizacji zawartej umowy uczestnictwa Pana/Pani dziecka w organizowanym przez Administratora turnusie oraz przez okres realizacji projektów edukacyjnych i innych działań edukacyjnych Stowarzyszenia.
					</li>
					<li>
						W przypadku udzielenia zgody na przetwarzanie danych osobowych dla
						celów reklamowania Panu/Pani pozostałych usług Stowarzyszenie FPUNKT
						z siedzibą: ul. Długa 24A, 84-353 Mosty Pana/Pani
						dane osobowe będą przetwarzane przez okres lat 3, po upływie tego
						okresu zostaną one usunięte, chyba, że Administrator wcześniej
						uzyska zgodę na przetwarzanie danych osobowych, także po upływie
						tego okresu.
					</li>
					<li>
						<ul>
							Jednocześnie informujemy, że przysługują Panu/Pani następujące
							uprawnienia:
							<li>
								- żądania od Administratora w każdym czasie dostępu do przekazanych danych osobowych,
							</li>
							<li>
								- prawo do sprostowania lub ograniczenia przetwarzania danych osobowych,
							</li>
							<li>
								- prawo do żądania przeniesienia danych osobowych do innego
								Administratora,
							</li>
							<li>
								- prawo sprzeciwu wobec operacji przetwarzania danych osobowych,
							</li>
							<li>
								- prawo do żądania niezwłocznego usunięcia dotyczących danych
								osobowych ze zbiorów prowadzonych przez Administratora,
							</li>
							<li>
								- prawo do cofnięcia w każdym czasie zgody na przetwarzanie danych osobowych w takiej formie, w jakiej była ona wyrażona, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem,
							</li>
							<li>
								- prawo do wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych na ewentualne naruszenia w zakresie ochrony danych osobowych.
							</li>
						</ul>
					</li>
					<li>
						Administrator niezwłocznie zrealizuje Pana/Pani żądania o których mowa powyżej, chyba, że przepisy powszechnie obowiązującego prawa, w szczególności Ogólnego rozporządzenia nie przewidują możliwości realizacji uprawnienia w odniesieniu do wskazanych w żądaniu danych osobowych. O fakcie niemożności zrealizowania zgłoszonego żądania ze względu na przepisy obowiązującego prawa Administrator powiadomi Pana/Panią niezwłocznie.
					</li>
				</ol>
			</div>
			<div className='policy'>
				<h3>
					Informacja o przetwarzaniu danych osobowych w celu prowadzenia
					korespondencji e-mail
				</h3>
				<ol>
					Szanowny Kliencie, <br />
					Zgodnie z art. 13 ust.1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (Ogólne rozporządzenie o ochronie danych), dalej jako „RODO”, informujemy, że:
					<li>
						Podanie przez Ciebie swoich danych osobowych w postaci adresu poczty elektronicznej miało charakter dobrowolny. Dzięki temu mamy możliwość udzielić Ci informacji o które prosiłeś w przesłanej do Nas wiadomości.
					</li>
					<li>
						Administratorem Twoich danych osobowych jesteśmy My – Stowarzyszenie FPUNKT z siedzibą: ul. Długa 24A, 84-353 Mosty, NIP: 841 171 94 70, KRS: 0000642213, REGON: 365658076
					</li>
					<li>
						We wszystkich sprawach związanych z przetwarzaniem przez nas Twoich danych osobowych możesz kontaktować się z naszym Inspektorem pisząc na adres e-mail: kontakt@osadawiedzy.pl.
					</li>
					<li>
						Twoje dane osobowe przekazane w treści przesłanej do Nas wiadomości e-mail będą przetwarzane wyłącznie w celu udzielenia Tobie wyczerpujących informacji o które prosiłeś, na podstawie dobrowolnej zgody, którą wyraziłeś poprzez wyraźne działanie (wysłanie do nas wiadomości e-mail z żądaniem odpowiedzi), zgodnie z art. 6 ust. 1 lit. a RODO.
					</li>
					<li>
						Odbiorcami danych kontrahentów lub pracowników kontrahentów i innych osób uprawnionych do reprezentowania kontrahentów, w postaci służbowych adresów e-mail oraz innych danych identyfikacyjnych będą wybrani kontrahenci Stowarzyszenia FPUNKT w sytuacji, gdy jest to niezbędne dla realizacji zawartych z nimi umów.
					</li>
					<li>
						Przekazane przez Ciebie dane nie zostaną powierzone ani udostępnione w żaden sposób innym podmiotom, za wyjątkiem organów publicznych, które mogą otrzymywać dane osobowe w ramach konkretnego postępowania przewidzianego prawem UE lub przepisami prawa polskiego.
					</li>
					<li>
						Na podstawie przekazanych przez Ciebie danych osobowych nie będą podejmowane w sposób automatyczny żadne decyzje, nie będziesz podlegał profilowaniu o którym mowa w art. 22 ust. 1 i 4 RODO.
					</li>
					<li>
						Przekazane przez Ciebie dane osobowe będą przechowywane w prowadzonych przez Nas zbiorach przez okres prowadzenia korespondencji, po upływie tego okresu Twoje dane mogą być przechowywane przez Nas wyłącznie w celach dowodowych dla zabezpieczenia się przed ewentualnymi roszczeniami o charakterze prywatnoprawnym lub publicznoprawnym.
					</li>
					<li>
						Przetwarzanie danych osobowych w innych celach lub w innym zakresie niż wskazane w punktach poprzedzających wymaga uzyskania Twojej wyraźnej zgody.
					</li>
				</ol>
				<ol>
					Jednocześnie informujemy, że przysługują Tobie następujące
					uprawnienia:
					<li>
						żądania od Administratora w każdym czasie dostępu do przekazanych danych osobowych,
					</li>
					<li>
						prawo do sprostowania lub ograniczenia przetwarzania danych osobowych,
					</li>
					<li>
						prawo do żądania przeniesienia danych osobowych do innego Administratora,
					</li>
					<li>
						prawo sprzeciwu wobec operacji przetwarzania danych osobowych,
					</li>
					<li>
						prawo do żądania niezwłocznego usunięcia dotyczących danych osobowych ze zbiorów prowadzonych przez Administratora,
					</li>
					<li>
						prawo do cofnięcia w każdym czasie zgody na przetwarzanie danych osobowych w takiej formie, w jakiej była ona wyrażona, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem,
					</li>
					<li>
						prawo do wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych na ewentualne naruszenia w zakresie ochrony danych osobowych.
					</li>
					Bez zbędnej zwłoki zrealizujemy Twoje żądania o których mowa powyżej, chyba, że przepisy powszechnie obowiązującego prawa, w szczególności RODO nie przewidują możliwości realizacji uprawnienia w odniesieniu do wskazanych w żądaniu danych osobowych. O fakcie niemożności zrealizowania zgłoszonego żądania ze względu na przepisy obowiązującego prawa powiadomimy Cię niezwłocznie.
				</ol>
			</div>
			<div className='policy'>
				<h3>Informacja o przetwarzaniu danych</h3>
				<ol>
					Szanowny Użytkowniku,
					<br /> od 25 maja 2018 roku stosujemy przepisy Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (dalej jako RODO). W związku z nowymi regulacjami pozyskując Twoje dane informujemy, że:
					<li>
						Podanie przez Ciebie swoich danych osobowych jest dobrowolne, ale ich niepodanie uniemożliwi Nam udzielenie Tobie wszelkich informacji o które prosisz w zapytaniu.
					</li>
					<li>
						Administratorem Twoich danych będzie Stowarzyszenie FPUNKT z siedzibą: ul. Długa 24A, 84-353 Mosty, NIP: 841 171 94 70, KRS: 0000642213, REGON: 365658076
					</li>
					<li>
						We wszystkich sprawach związanych z przetwarzaniem przez nas Twoich danych osobowych możesz kontaktować się z naszym Inspektorem pisząc na adres e-mail: kontakt@osadawiedzy.pl
					</li>
					<li>
						Twoje dane osobowe będą przetwarzane przez Nas wyłącznie w celu udzielenia Tobie wszelkich informacji o które prosisz w zapytaniu na podstawie zgody, którą wyrażasz poprzez jednoznaczne działanie z zamiarem uzyskania od Nas odpowiedzi zgodnie z art. 6 ut. 1 lit. a RODO.
					</li>
					<li>
						Twoje dane osobowe mogą zostać powierzone wyłącznie:
						<br />
						Przedsiębiorstwom IT zajmującym się obsługą informatyczną oraz prowadzeniem strony internetowej Administratora, wyłącznie w takim zakresie, w jakim jest to niezbędne dla wykonywania przez te podmioty obowiązków wynikających z umów zawartych z Administratorem.
						<br />
						Dane osobowe nie będą udostępniane lub powierzane w żaden sposób innym podmiotom, za wyjątkiem organów publicznych, które mogą otrzymywać dane osobowe w ramach konkretnego postępowania przewidzianego prawem UE lub przepisami prawa polskiego.
					</li>
					<li>
						Twoje dane osobowe będą przetwarzane przez Nas przez okres niezbędny dla realizacji wyżej wskazanego celu, a po tym czasie wyłącznie w przypadku, gdy jest to niezbędne dla realizacji prawnie uzasadnionego interesu Administratora (ochrona przed roszczeniami o charakterze prywatnoprawnym oraz publicznoprawnym).
					</li>
					<li>
						Na podstawie przekazanych danych osobowych nie będą podejmowane wobec Twojej osoby jakiekolwiek zautomatyzowane decyzje, w tym profilowanie o którym mowa w art. 22 ust. 1 i 4 Ogólnego rozporządzenia.
					</li>
					<li>
						Jednocześnie informujemy, że przysługują Tobie następujące
						uprawnienia:
						<ul>
							<li>
								– żądania od Administratora w każdym czasie dostępu do przekazanych danych osobowych,
							</li>
							<li>
								– prawo do sprostowania lub ograniczenia przetwarzania danych osobowych,
							</li>
							<li>
								– prawo do żądania przeniesienia danych osobowych do innego Administratora,
							</li>
							<li>
								– prawo sprzeciwu wobec operacji przetwarzania danych osobowych,
							</li>
							<li>
								– prawo do żądania niezwłocznego usunięcia dotyczących danych osobowych ze zbiorów prowadzonych przez Administratora,
							</li>
							<li>
								– prawo do cofnięcia w każdym czasie zgody na przetwarzanie danych osobowych w takiej formie, w jakiej była ona wyrażona, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem,
							</li>
							<li>
								– prawo do wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych na ewentualne naruszenia w zakresie ochrony danych osobowych.
							</li>
						</ul>
					</li>
					<li>
						Administrator niezwłocznie zrealizuje Twoje żądania o których mowa powyżej, chyba, że przepisy powszechnie obowiązującego prawa, w szczególności Ogólnego rozporządzenia nie przewidują możliwości realizacji uprawnienia w odniesieniu do wskazanych w żądaniu danych osobowych. O fakcie niemożności zrealizowania zgłoszonego żądania ze względu na przepisy obowiązującego prawa Administrator powiadomi Pana/Panią niezwłocznie.
					</li>
				</ol>
			</div>
		</>
	);
};

export default PolicyContent;
